import React from "react";
import { Link } from "react-router-dom";
// import { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
import logo from '../assets/images/logo240.png';
import enamad from '../assets/images/enamad.png';
import samandehi from '../assets/images/samandehi.png';

// import axios from "axios";
import "../App.css";

const Footer = () => {
  return (
    <>
		<footer>
			<div className="pagewrapper" id="footer">
				<div className="container box-sizing">
					<div className="copyright">
						<a href="#" title><img src={logo} alt="" className="logo" /></a>
						طراحی و توسعه و بهینه سازی توسط <a href="https://wwwebsite.ir/" title="وب سایت پارسی">وب سایت پارسی</a>
					</div>
					<a href="https://trustseal.enamad.ir/?id=215454&Code=volu3hhOjej6js4yFdcE" title><img src="https://Trustseal.eNamad.ir/logo.aspx?id=215454&Code=volu3hhOjej6js4yFdcE" alt="" className="certificate" width={89} height={89} /></a>
					<a href title><img src={samandehi} alt="" className="certificate" width={89} height={89} /></a>
				</div>
			</div>
		</footer>

    </>
  );
};

export default Footer;
